import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import moment from "moment";
import Axios from "axios";

import AttendanceIcon from "../../../../../Assets/Logo/AttendanceIcon.svg";
import { url } from "../../../../../Config/Config";
import { useStyles } from "../TeacherDashboard.css";
import { getUserRefreshToken } from "../../../../../Redux/Actions/actions";

class TeacherAttendanceCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      presentCount: 0,
      absentCount: 0,
      leaveCount: 0,
    };
  }

  componentDidMount() {
    this.getAttendanceData();
  }

  getAttendanceData = async () => {
    try {
      const response = await Axios.get(`${url}/api/staff-attendance`, {
        params: {
          staffId: this.props.userId,
        },
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      let filterAttendance = response.data.attendances.filter(
        (data) =>
          moment(data.date).format("YYYY") ===
            moment(new Date()).format("YYYY") &&
          moment(data.date).format("MM") === moment(new Date()).format("MM")
      );
      let presentCount = filterAttendance.filter(
        (data) => data.status === "P"
      ).length;
      let absentCount = filterAttendance.filter(
        (data) => data.status === "A"
      ).length;
      let leaveCount = filterAttendance.filter(
        (data) => data.status === "L"
      ).length;
      this.setState({
        presentCount,
        absentCount,
        leaveCount,
      });
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getAttendanceData();
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { presentCount, absentCount, leaveCount } = this.state;
    let totalDays = moment(new Date()).daysInMonth();
    return (
      <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
        <Paper>
          <ListItem style={{ display: "flex", alignItems: "center" }}>
            <img
              src={AttendanceIcon}
              alt="attendance"
              style={{ width: 40, height: 40 }}
            />
            <div>Attendances</div>
          </ListItem>
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Current Month:</b>
              <div>{moment(new Date()).format("MMMM")}</div>
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Total Days:</b>
              <div> {totalDays}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Present Days:</b>
              <div>{presentCount}</div>
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Absent Days:</b>
              <div> {absentCount}</div>
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Leave Days:</b> <div>{leaveCount}</div>
            </ListItem>
          </div>
          <ListItem>
            <b style={{ flexGrow: 1 }}>Not Recorded Days:</b>
            <div>{totalDays - presentCount - absentCount - leaveCount}</div>
          </ListItem>
        </Paper>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(TeacherAttendanceCard));
